export const getSettings = state => state.settings;
export const getLastLocation = state => state.settings.lastLocation;
export const getChosenLang = state => state.settings.chosenLang;
export const getLayoutItems = (state, keyLayout) => state.settings.gridLayouts?.[keyLayout];
export const getDataLoading = state => state.settings.dataLoading;
export const getIsBlank = state => state.settings.isNewBlank;
